export const LANDING_ACCESS_CREDENTIALS = "landing/ACCESS_CREDENTIALS";
export const LANDING_ACCESS_NAFEM = "landing/ACCESS_NAFEM";
export const LANDING_ACCESS_SNAP = "landing/ACCESS_SNAP";
export const LANDING_ACCESS_FIREFLY = "landing/ACCESS_FIREFLY";
export const LANDING_ACCESS_EMAIL = "landing/ACCESS_EMAIL";
export const LANDING_ACCESS_IS_FIRST = "landing/ACCESS_IS_FIRST";